module.exports = __webpack_public_path__ + "img/broadcast-work-icon6.554ce1ee.png";